import { render } from "./PhotoItem.vue?vue&type=template&id=e8dd5014&scoped=true"
import script from "./PhotoItem.vue?vue&type=script&lang=js"
export * from "./PhotoItem.vue?vue&type=script&lang=js"

import "./PhotoItem.vue?vue&type=style&index=0&id=e8dd5014&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8dd5014"]])

export default __exports__